export const Tooltip = {
  baseStyle: {
    bg: "gray.700",
    color: "white",
  },
};
